import React, { PropTypes, Component } from 'react';
import { Set } from 'immutable';

class MultiSelectCheckbox extends Component {
  constructor(props) {
    super(props);

    this.onRefChange = this.onRefChange.bind(this);
  }

  onRefChange(referenceId) {
    const { selected, onChange } = this.props;

    if (selected) {
      const items = Set(selected);

      if (items.includes(referenceId)) {
        onChange(items.delete(items.keyOf(referenceId)).toArray());
      } else {
        onChange(items.add(referenceId).toArray());
      }
    } else {
      onChange([referenceId]);
    }
  }

  render() {
    const { fields, label, selected } = this.props;

    const isChecked = id => selected && !!selected.find(ref => ref === id);
    const renderCheckboxClassname = id =>
      isChecked(id) ? 'ui checked checkbox' : 'ui checkbox';
    const isCheckedLabel = id => (isChecked(id) ? 'on' : 'off');

    return (
      <div className="field">
        <label>{label}</label>
        <div className="inline fields ui grid checkBoxList">
          {fields &&
            fields.map(box => {
              const handleCheck = () => this.onRefChange(box.id);

              return (
                <div key={box.id} className="four wide column field">
                  <div
                    className={renderCheckboxClassname(box.id)}
                    onClick={handleCheck}
                  >
                    <input
                      type="checkbox"
                      onChange={handleCheck}
                      checked={isChecked(box.id)}
                      className="hidden"
                      value={isCheckedLabel(box.id)}
                    />
                    <label>{box.label}</label>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}

MultiSelectCheckbox.PropTypes = {
  label: PropTypes.string.isRequired,
  fields: PropTypes.array.isRequired,
  selected: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

export default MultiSelectCheckbox;



// WEBPACK FOOTER //
// ./src/modules/common/components/MultiSelectCheckbox.js